// @flow

import removeEstimateOptional from '../../../Services/removeEstimateOptional';
import type { RemoveEstimateOptionalParams } from '../../../types';

export default (params: RemoveEstimateOptionalParams) => async (dispatch: Function) => dispatch(removeEstimateOptional(params))